import { createSlice } from "@reduxjs/toolkit";
import {getInvoices } from "../reduxApi/invoicesReduxApi";

const InvoicesSlice = createSlice({
    name: 'invoices',
    initialState: {
    status: 'idel',
    invoices: [],
    },
    reducers: {
        deleteinvoicesAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.invoices.findIndex((item) => item.invoices.ROWID === id);
                if (index !== -1) {
                    state.invoices.splice(index, 1);
                }
            });
        },     
        updateinvoicesAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.invoices.findIndex((item) => item?.invoices?.ROWID === action.payload.invoicesId)
            if (index != -1) {
                state.invoices.splice(index, 1, { invoices: action.payload.formData })
            }
        },
        addinvoicesAction: (state, action) => {
            console.log("Adding invoices:", action.payload); 
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.invoices.unshift(temp);
            console.log("Temporary invoices data:", temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInvoices.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getInvoices.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing invoices Data",action.payload)                
                state.invoices = action.payload.data.invoicesData;
            })
    }
})
export const { deleteinvoicesAction, updateinvoicesAction, addinvoicesAction } = InvoicesSlice.actions
export default InvoicesSlice.reducer